<div class="row d-flex align-items-center justify-content-between">

  <div class="col-md-6 d-flex align-items-center justify-content-start">
    <button class="btn btn-info btn-animate " ngbTooltip="Agregar Nuevo" *ngIf="!this.addRow"
            type="button" (click)="addNewRow()">
      <i class="ft-plus"></i>
    </button>

    <button class="btn btn-warning ml-1 btn-animate "
            ngbTooltip="Actualizar datos en tabla" type="button"
            (click)="this.getDataSource()">
      <i class="ft-refresh-ccw"></i>
    </button>

    <button class="btn btn-success ml-1 btn-animate "
            type="button" ngbTooltip="Exportar tabla en Excel"
            (click)="exportTable()">
      <i class="bi bi-file-earmark-excel-fill"></i>
    </button>

    <button class="btn btn-dark ml-1 btn-animate "
            type="button" ngbTooltip="Regresar"
            (click)="exit()">
      <i class="ft-corner-up-left"></i>
    </button>

  </div>

  <!-- Paginador -->
  <mat-paginator class="col-md-6" [pageSize]="10" [pageSizeOptions]="[5, 10, 15]"></mat-paginator>

</div>

<div class="row">
  <div class="col mt-1">
    <mat-form-field class="search-field w-100">
      <mat-label>Buscar</mat-label>
      <input matInput (input)="applyFilter($event)" placeholder="Filtrar datos" #input/>
    </mat-form-field>
  </div>
</div>

<div *ngIf="this.isLoading"
     style="display: flex; justify-content: center; align-items: center; padding-top: 5px; padding-bottom: 5px;">
  <mat-progress-spinner
    color="primary"
    mode="indeterminate"
    [diameter]="30">
  </mat-progress-spinner>
  <span class="ml-1">Cargando</span>
</div>

<div #idExportar style="overflow-x: auto;">

  <table mat-table [dataSource]="dataSource" class="table table-striped mat-elevation-z8"
         *ngIf="displayedColumns.length>0" style="width: 100%;">


    <div *ngFor="let columna of displayedColumns; let i = index ">
      <ng-container matColumnDef="{{columna}}">


        <th mat-header-cell *matHeaderCellDef> {{dataNames[i]}}</th>
        <td mat-cell *matCellDef="let element; let j = index">

          <div *ngIf="dataNames[i]!=this.constants.ACCIONES">
            <ng-container *ngIf="(element['isNew'] || (editingRow === j && editableColumn[i]===true)); else miTemplate">


              <input *ngIf="formatColumn[i]==this.constants.TEXT" matInput type="text" class="w-100"
                     [(ngModel)]="element[displayedColumns[i]]" [placeholder]="dataNames[i]"/>

              <input *ngIf="formatColumn[i]==this.constants.NUMBER" matInput type="number" class="w-100"
                     [(ngModel)]="element[displayedColumns[i]]" [placeholder]="dataNames[i]"/>

              <input *ngIf="formatColumn[i]==this.constants.DATE" matInput type="date" class="w-100"
                     [(ngModel)]="element[displayedColumns[i]]" [placeholder]="dataNames[i]"/>

              <input *ngIf="formatColumn[i]==this.constants.CHECK" type="checkbox"
                     [(ngModel)]="element[displayedColumns[i]]" [placeholder]="dataNames[i]"
                     [checked]="element[displayedColumns[i]] == true" style="transform: scale(1.5);"/>

            </ng-container>

            <ng-template #miTemplate let-id="{{j}}">
              <div *ngIf="formatColumn[i]!==this.constants.CHECK">{{ element[displayedColumns[i]] }}</div>

              <input *ngIf="formatColumn[i]==this.constants.CHECK" type="checkbox"
                     style="transform: scale(1.5);"
                     [checked]="element[displayedColumns[i]] == true" disabled/>

            </ng-template>

          </div>

          <div *ngIf="dataNames[i]==this.constants.ACCIONES">
            <ng-container *ngIf="element['isNew']">

              <i class="ft-save text-success cursor-pointer ng-star-inserted h5" (click)="saveNew(element)"
                 ngbTooltip="Guardar"></i>
              <i class="ft-slash text-warning cursor-pointer ng-star-inserted h5 ml-2" (click)="cancelNew(element)"
                 ngbTooltip="Cancelar"></i>

            </ng-container>
            <ng-container *ngIf="!element['isNew'] && editingRow === j">

              <i class="ft-save text-success cursor-pointer ng-star-inserted h5" (click)="saveEdit(element)"
                 ngbTooltip="Guardar"></i>
              <i class="ft-slash text-warning cursor-pointer ng-star-inserted h5 ml-2" (click)="cancelEdit()"
                 ngbTooltip="Cancelar"></i>

            </ng-container>
            <ng-container *ngIf="!element['isNew'] && editingRow !== j">

              <i class="ft-edit text-info cursor-pointer ng-star-inserted h5" (click)="startEdit(j)"
                 ngbTooltip="Editar"></i>

              <i *ngIf="this.parametrosTablaEdit.delete!==undefined && this.parametrosTablaEdit.delete===true"
                 class="ft-trash text-danger cursor-pointer ng-star-inserted h5 ml-2" (click)="deleteRow(element)"
                 ngbTooltip="Eliminar"></i>

            </ng-container>

          </div>
        </td>


      </ng-container>

    </div>

    <!-- Encabezado y filas -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="20" style="text-align: center;">No hay informacion para
        mostrar {{input.value}}</td>
    </tr>


  </table>


</div>

<ngx-spinner style="color:#ffffff;">Cargando</ngx-spinner>
